import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

export const HiddenInput = styled(FormControl)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  opacity: 0;
  cursor: pointer;
`;
